
import { TranslationService } from "@/core/services/TranslationService";
import { FormatMethods } from "@/helpers/data-format";
import { computed, defineComponent, PropType, toRefs } from "vue";
import VZKeyValue from "@/components/content/VZKeyValue.vue";
import { ILocation } from "@/interfaces/iLocation";
export default defineComponent({
  name: "LocationDetail",
  inheritAttrs: false,
  props: {
    data: { type: Object as PropType<ILocation>, required: true },
  },
  components: { VZKeyValue },
  setup(props) {
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const { data } = toRefs(props);
    const format = computed(() => {
      return FormatMethods;
    });
    const items = computed(() => {
      return [
        {
          header: t("common.startDate"),
          value: data.value.startDate
            ? format.value.convertUTCToLocalDate(data.value.startDate)
            : "",
        },
        {
          header: t("common.endDate"),
          value: data.value.endDate
            ? format.value.convertUTCToLocalDate(data.value.endDate)
            : "",
        },
        // {
        //   header: t("common.status"),
        //   value: data.value.locationCodeText
        //     ? format.value.TitleCase(data.value.locationCodeText?.toLowerCase())
        //     : "",
        // },
        {
          header: t("common.createdDate"),
          value: data.value.createdDate
            ? format.value.convertUTCToLocalDate(
                data.value.createdDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.createdBy"),
          value: data.value.createdBy,
        },
        {
          header: t("common.updatedDate"),
          value: data.value.updateDate
            ? format.value.convertUTCToLocalDate(
                data.value.updateDate,
                "MM-DD-YYYY hh:mm A"
              )
            : "",
        },
        {
          header: t("common.updatedBy"),
          value: data.value.updatedBy,
        },
      ];
    });
    return {
      items,
    };
  },
});
